import { useState } from 'react';
import { FormControl, Grid, Typography, Tooltip, Icon, IconButton } from '@mui/material';
import awsconfig from '../../aws-exports';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { FileUpload } from '../../components/inputComponents/FileUpload/FileUpload.component';
import { AllowedTextAlignments } from '../../constants/currency-constants';
import { FileUploadWrapperProps } from '../../types/componentTypes/CurrencyTypes';
import TextFieldWrapper from '../TextFieldWrapper/TextFieldWrapper';
import { getEnvAndRegion, getPublicImagePath } from '../../components/inputComponents/FileUpload/fileUploadHelpers';

const FileUploadWrapper = ({ props }: FileUploadWrapperProps) => {
    const {
        currencyId,
        initialFileName,
        fileDeleteButtonDisabled,
        handleDeleteIconFromS3,
        setFileLocation,
        setPageHasBeenModified,
        setNotificationState
    } = props;


    const [fileName, setFileName] = useState(initialFileName);
    const [showFileUpload, setShowFileUpload] = useState(!initialFileName);

    const handleDeleteIcon = () => {
        handleDeleteIconFromS3();
        setShowFileUpload(true);
    }

    const handleUploadIcon = (files: Array<string>) => {
        const path = `icons/${currencyId}`;
        const { region, env, isValidRegion } = getEnvAndRegion(awsconfig.aws_user_files_s3_bucket);
        const currencyFilePath = getPublicImagePath(env, isValidRegion, region, path);

        setFileName(files[0])
        setFileLocation(`${currencyFilePath}/${files[0]}`);
        setPageHasBeenModified(true);
        setShowFileUpload(false);
    }

    return (
        <FormControl sx={{ m: 1, width: 400 }}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center'>
                <Grid item>
                    <Typography>Currency Icon (Optional)</Typography>
                </Grid>

                <Grid item>
                    <Tooltip
                        placement={AllowedTextAlignments.Right}
                        sx={{ marginTop: '-2px' }}
                        data-testid='file-upload-icon-tooltip'
                        title='Icon resolution: 16x16px. Allowed formats: PNG, SVG'>
                        <Icon className='icon-style' fontSize='large'>
                            <HelpOutlineIcon />
                        </Icon>
                    </Tooltip>
                </Grid>

                {!showFileUpload && (
                    <>
                        <Grid item xs={11}>
                            <TextFieldWrapper
                                className='file-input-field'
                                disabled
                                sx={{ background: 'white' }}
                                fullWidth
                                id='currency-input-name'
                                variant='outlined'
                                value={fileName}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton
                                disabled={fileDeleteButtonDisabled}
                                size='medium'
                                onClick={handleDeleteIcon}>
                                <DeleteIcon className='delete-icon' />
                            </IconButton>
                        </Grid>
                    </>
                )}

                {showFileUpload && (
                    <FileUpload
                        isEdit={true}
                        uploadCallback={handleUploadIcon}
                        maxFiles={1}
                        placeholder={'No file chosen'}
                        bucket='public'
                        filePath={`icons/${currencyId}`}
                        usePublicDomain={true}
                        customAllowedFileTypes={['image/png', 'image/jpeg', 'image/svg+xml']}
                        setNotificationState={setNotificationState}
                    />
                )}
            </Grid>
        </FormControl>
    );
};

export default FileUploadWrapper;
